import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ErrorText from "../../components/errorText";
import logger from "../../utils/logger";

interface Props {
  onSaveDrawerClose: (obj: any) => void;
  isActionError?: boolean;
  updateActionDays?: any; // Accept object to handle Facebook audience data
}

const ActionFacebookAudience: React.FC<Props> = ({
  onSaveDrawerClose,
  isActionError,
  updateActionDays = {} // Default to empty object instead of empty string
}) => {
  const StoreData = useSelector((state: any) => state?.rootReducers);
  
  // FIXED: Initialize from updateActionDays object properties with default audience name
  const [selectedAdAccount, setSelectedAdAccount] = useState(
    typeof updateActionDays === 'object' ? updateActionDays.adAccountId || "" : ""
  );
  const [audienceName, setAudienceName] = useState(
    typeof updateActionDays === 'object' ? 
      (updateActionDays.audienceName || "3sigma crm audience") : 
      "3sigma crm audience" // DEFAULT: Set default audience name
  );
  
  // Get Facebook integration from user integrations
  const userIntegrations = StoreData?.userData?.userDetails?.userIntegrations || [];
  const facebookIntegration = userIntegrations.find(
    (integration: any) => 
      integration.integration?.key === "facebook_audience" && 
      integration.isActive === true
  );
  
  const adAccounts = facebookIntegration?.details?.adaccounts || [];
  
  // Add useEffect to handle prop changes when drawer reopens
  useEffect(() => {
    logger.log("ActionFacebookAudience: updateActionDays changed:", updateActionDays);
    
    if (typeof updateActionDays === 'object' && updateActionDays) {
      setSelectedAdAccount(updateActionDays.adAccountId || "");
      // FIXED: Set audience name from updateActionDays or use default
      setAudienceName(updateActionDays.audienceName || "3sigma crm audience");
    } else {
      // Reset to default values if no data
      setSelectedAdAccount("");
      setAudienceName("3sigma crm audience"); // DEFAULT: Use default name when resetting
    }
  }, [updateActionDays]);

  // FIXED: Include audienceName in the configData object
  const handleSave = () => {
    if (!selectedAdAccount || !audienceName) {
      return;
    }
    
    const configData = {
      adAccountId: selectedAdAccount,
      audienceName: audienceName // FIXED: Include audience name in the config data
    };
    
    logger.log("ActionFacebookAudience: Saving config data:", configData);
    onSaveDrawerClose(configData);
  };
  
  return (
    <div className="row">
      <div className="form-group action_select">
        {facebookIntegration ? (
          <>
            <label>Select Facebook Ad Account</label>
            <select
              className="form-select"
              value={selectedAdAccount}
              onChange={(e) => setSelectedAdAccount(e.target.value)}
            >
              <option value="">Choose Ad Account</option>
              {adAccounts.map((account: any) => (
                <option key={account.id} value={account.id}>
                  {account.name}
                </option>
              ))}
            </select>
            
            <label>Audience Name</label>
            <input
              type="text"
              className="form-control"
              value={audienceName}
              onChange={(e) => setAudienceName(e.target.value)}
              placeholder="Enter custom audience name"
            />
            
            {isActionError && (
              <ErrorText message="Please select ad account and enter audience name" />
            )}
          </>
        ) : (
          <div className="alert alert-warning">
            Facebook integration not found. Please connect your Facebook account first.
          </div>
        )}
      </div>
      
      <div className="auto_action_form_btn">
        <button
          type="button"
          className="btn btn-primary-save"
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default ActionFacebookAudience;